import type { VariantDeliveryMethods } from '@libs/common-types';

type FulfilmentMethod = 'bopis' | 'sdd' | 'sth';

type GetStoreIdParams = {
    fulfilmentMethod: FulfilmentMethod;
    tailoredVariant?: VariantDeliveryMethods | null;
};

export const getStoreId = ({ fulfilmentMethod, tailoredVariant }: GetStoreIdParams): string => {
    if (fulfilmentMethod === 'sth') return '';

    const storeId = fulfilmentMethod === 'bopis' ? tailoredVariant?.BOPIS?.storeId : tailoredVariant?.SDD?.storeId;

    return storeId?.padStart(4, '0') ?? '';
};
